import React, { useState, useEffect } from "react";
import {
  Stack,
  Box,
  Typography,
  Button,
  Snackbar,
  Alert,
  IconButton,
  TextField,
} from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import { getRoleData, addRole, getPermissionData,getAllowedRoleData } from "../../../store/actions/rolePermissionActions";
import { useDispatch, useSelector } from "react-redux";
import AddRoleForm from "./AddRoleForm";
import { useHistory } from "react-router-dom"
import PermissionWrapper from "../PermissionWrapper";
export default function RoleList() {
  const dispatch = useDispatch();
  const history = useHistory()
  const [rows, setRows] = useState([
    // { id: 1, name: "Rakesh", email: "rakesh@mail.com", role: "Admin", location: ["Hyderabad"] },
    // { id: 2, name: "Itishree", email: "itishree@mail.com", role: "Manager", location: ["Chennai", "Bangalore"] },
  ]);
  const [filteredRows, setFilteredRows] = useState(rows);
  const [search, setSearch] = useState("");
  const [openForm, setOpenForm] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [snack, setSnack] = useState({ open: false, message: "", severity: "info" });
  const [form, setForm] = useState({ name: "" });
  const permissionsData = useSelector(
    (state) => state.rolePermissionReducer.userPermissionData
);


  useEffect(() => {

    fetchDataFromServer();
  }, []);

  const fetchDataFromServer = () => {

    // setIsLoading(true);
    setSnack({ open: true, message: "loading data from server...!", severity: "info" });
    const userId = localStorage.getItem('userId') ;
    const  roleId= permissionsData?.roleId ;
    dispatch(
      // getRoleData()
      getAllowedRoleData(roleId,userId)
    ).then((res) => {
      // setIsLoading(false);
      setRows(res);
      setFilteredRows(res);
      setSnack({ open: false, message: "", severity: "info" });
    });
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (!value) {
      setFilteredRows(rows);
      return;
    }
    const filtered = rows.filter((r) =>
      [r.name].some((field) =>
        field.toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredRows(filtered);
  };
  const handleClearSearch = () => {
    setSearch("");
    setFilteredRows(rows);
  };
  const handleAddUser = () => {
    setEditUser(null);
    setForm({ name: "" });
    setOpenForm(true);
  };
  const handleEditUser = (user) => {
    setEditUser(user);
    setForm(user);
    setOpenForm(true);
  };
  const handleDeleteUser = (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      const updated = rows.filter((r) => r.id !== id);
      setRows(updated);
      setFilteredRows(updated);
      setSnack({ open: true, message: "User deleted successfully", severity: "success" });
    }
  };
  const handleViewPermission = async (roleId, roleName) => {
    try {
      setSnack({ open: true, message: "Loading permissions...", severity: "info" });
      const res = await dispatch(getPermissionData(roleId));
      console.log("Permission data:", res);

      if (res) {
        // Save the permission data to Redux or navigate with state
        // Example: Navigate and send data
        // history.push("/settings/role/permission",{permissionData: { data: res ,type:"role",id:roleId,name:roleName}});
        history.push("/settings/role/permission", { permissionData: { data: res, details: { type: "Role", id: roleId, name: roleName } } });
      }
    } catch (error) {
      console.error("Failed to load permissions:", error);
      setSnack({ open: true, message: "Failed to load permissions", severity: "error" });
    } finally {
      setSnack({ open: false, message: "", severity: "info" });
    }
  };
  const handleSubmitForm = async () => {
    if (!form.name) {
      setSnack({ open: true, message: "Please fill all required fields", severity: "warning" });
      return;
    }
    if (editUser) {
      const res = await dispatch(addRole({ name: form.name }, form.id, "edit"))
      const newRole = { id: res?.id, ...form };
      const updated = rows.map(row => row.id === form.id ? newRole : row);
      setRows(updated);
      setFilteredRows(updated);
      setRows(updated);
      setFilteredRows(updated);
      setSnack({ open: true, message: "User updated successfully", severity: "success" });
    } else {
      const res = await dispatch(addRole(form, "", "add"))
      const newRole = { id: res?.id, ...form };
      const updated = [...rows, newRole];
      setRows(updated);
      setFilteredRows(updated);
      setSnack({ open: true, message: "User added successfully", severity: "success" });
    }
    setOpenForm(false);
  };
  const columns = [

    // { field: "id", headerName: "S.No" },
    {
      field: "id", headerName: "S.No", width: 90,

      renderCell: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);
        return index + 1;
      }
    },
    { field: "name", headerName: "Name", flex: 1 },

    // {
    //   field: "viewPermissions",
    //   headerName: "View Permissions",
    //   flex: 1,
    //   renderCell: () => (
    //     <Button
    //       variant="contained"
    //       color="primary"
    //       size="small"
    //       onClick={() => window.location.href = "/settings/role/permission"}
    //     >
    //       View
    //     </Button>
    //   ),
    // },
    {
      field: "viewPermissions",
      headerName: "Permissions",
      flex: 1,
      renderCell: (params) => (
        <PermissionWrapper category='roles' level="READ_WRITE">
          <Button
            variant="contained"
            color="primary"
            size="small"
            // onClick={() => window.location.href = "/settings/role/permission"}
            onClick={() => handleViewPermission(params.row.id, params.row.name)}
          >
            Modify
          </Button>
        </PermissionWrapper>
      ),
    },

    {
      field: "actions",
      headerName: "Action",
      // width: 120,
      flex: "end",
      renderCell: (params) => (
        <>
         <PermissionWrapper category='roles' level="READ_WRITE">
            <IconButton color="primary" onClick={() => handleEditUser(params.row)}>
              <EditIcon />
            </IconButton>
          </PermissionWrapper>
          {/* <IconButton color="error" onClick={() => handleDeleteUser(params.row.id)}>
            <DeleteIcon />
          </IconButton> */}
        </>
      ),
    },
  ];
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        backgroundColor: '#fff',
        overflow: 'auto',
      }}
    >
      <Stack spacing={2} p={3}>
        {/* Header Row */}
        <Box display="flex" alignItems="center" justifyContent="space-between">
          {/* Left: Search */}
          <PermissionWrapper category='roles' level="READ_WRITE">
            <TextField
              label="Search Role"
              size="small"
              value={search}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {search && (
                      <IconButton onClick={handleClearSearch} edge="end">
                        <CloseIcon />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
              sx={{ flex: 1, maxWidth: '300px' }}
            />
          </PermissionWrapper>

          {/* Center: Title */}
          <Typography
            variant="h5"
            fontWeight={600}
            color="#0911A7"
            sx={{ flex: 1, textAlign: 'center' }}
          >
            Role Management
          </Typography>

          {/* Right: Add Role Button */}
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
          <PermissionWrapper category='roles' level="READ_WRITE">
              <Button
                startIcon={<AddIcon />}
                variant="contained"
                color="primary"
                onClick={handleAddUser}
              >
                Add Role
              </Button>
            </PermissionWrapper>
          </Box>
        </Box>

        {/* DataGrid */}
        <Box
          sx={{
            height: 'calc(100vh - 180px)',
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'rgba(11, 67, 135, 1)',
              color: '#fff',
              fontWeight: 600,
            },
            '& .MuiDataGrid-menuIconButton': { color: '#fff' },
          }}
        >
          <PermissionWrapper category='roles' level="READ_WRITE">
            <DataGridPro
              rows={filteredRows}
              columns={columns}
              disableRowSelectionOnClick
              hideFooterSelectedRowCount
            />
          </PermissionWrapper>
        </Box>

        {/* Dialog */}
        <AddRoleForm
          open={openForm}
          handleClose={() => setOpenForm(false)}
          handleSubmit={handleSubmitForm}
          form={form}
          setForm={setForm}
          editUser={editUser}
        />

        {/* Snackbar */}
        <Snackbar
          open={snack.open}
          autoHideDuration={3000}
          onClose={() => setSnack((prev) => ({ ...prev, open: false }))}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={() => setSnack((prev) => ({ ...prev, open: false }))}
            severity={snack.severity}
            sx={{ width: '100%' }}
          >
            {snack.message}
          </Alert>
        </Snackbar>
      </Stack>
    </Box>
  );

}

